import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing. Auth will not work.",
  );
}

// Flow type notes:
//  * PKCE stores the code_verifier in localStorage on the device that
//    requested the magic link. Coaches routinely request from a
//    laptop and click the email on their phone (range / on-course),
//    which lands in a browser that doesn't have the verifier. That's
//    the "PKCE code verifier not found in storage" error.
//  * Implicit flow returns the session tokens in the URL fragment of
//    the callback URL; `detectSessionInUrl: true` auto-parses them.
//    No verifier needed, works across devices, and the fragment is
//    never sent to our origin servers so it's not in access logs.
//    Plenty secure for a dashboard signed with a short-lived JWT.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    detectSessionInUrl: true,
    persistSession: true,
    storageKey: "arc-coach-auth",
    flowType: "implicit",
  },
});
